import React from 'react'
import ReactGA from 'react-ga'
import { useHistory } from 'react-router-dom'
import { SkeletonTheme } from 'react-loading-skeleton'

import { ReactComponent as ChevronRightIcon } from '../../../assets/icons/chevron-right.svg'

import Card from '../../../components/Card'
import Alert from '../components/Form/Alert'
import LoadMore from '../../../components/LoadMore'
import LoadingCards from './components/LoadingCards'
import NoResultsFound from '../components/NoResultsFound'
import { useGetNotifications } from '../../../hooks/useGetNotifications'
import { formatDate } from '../../../utils/formatters'
import { LIMIT, notificationTypes } from './constants'

import * as S from './styles'
import SideMenuTemplate from '../templates/SideMenu'

const Notifications = () => {
  const history = useHistory()
  const { professional, partner } = JSON.parse(localStorage.getItem('userData'))
  const professionalId = professional.id
  const partnerId = partner

  const { notifications, totalNotifications, loading, handleGetNotificationByProfessionalId } = useGetNotifications({ LIMIT })

  const shouldShowLoadMore = () => loading ? false : totalNotifications > notifications?.length && notifications.length > 0

  const goToPage = (url) => {
    history.push(`/${url}`)
    ReactGA.pageview(`/${url}`)
  }

  const loadMore = () => {
    return <LoadMore
      show={shouldShowLoadMore()}
      handleGetData={handleGetNotificationByProfessionalId}
      LIMIT={LIMIT}
    />
  }

  const renderNotification = (notification, index) => {
    const partnerData = notification.partners.find(partner => partner.partner === partnerId && partner.professionals)
    const professionalData = partnerData.professionals.find(prof => prof.professional === professionalId)
    const isRead = professionalData?.read
    const isNotAccepted = !professionalData?.accepted
    const isAccepted = professionalData?.accepted
    const isOfficial = notification?.notificationType === 'OFFICIAL'
    const isBothRead = (isOfficial && isAccepted) || (!isOfficial && isRead)
    return (
      <S.StyledCard key={`${notification.id}-${index}`} onClick={() => goToPage(`vets/notifications/notification-details/${notification.id}`)}>
        <Card full>
          <S.Avatar src={notificationTypes[notification.notificationType].avatar} alt="envelope-avatar" />
          <S.TextBlock>
            {(isNotAccepted && isOfficial && isRead) &&
              <S.WarningLabel>
                <S.WarningText> Confirmação pendente</S.WarningText>
              </S.WarningLabel>
            }
            <S.Subtitle isRead={isBothRead}>{notification.name}</S.Subtitle>
            <S.Text>{notification.message}</S.Text>
            <S.DateField>{formatDate({ date: notification.createdAt, capitalizeMonth: true })}</S.DateField>
          </S.TextBlock>
          <S.ButtonOpen onClick={() => goToPage(`notifications/notification-details/${notification.id}`)}>
            <ChevronRightIcon />
          </S.ButtonOpen>
        </Card>
      </S.StyledCard>
    )
  }

  return (
    <SkeletonTheme baseColor="#D9D9D9">
      <SideMenuTemplate>
        <S.MainContainer>
          <S.HeaderInfo>
            <S.Title>Avisos e Comunicados</S.Title>
            <Alert type='lock' show>
              Estes avisos são privados e outros veterinários da clínica não tem acesso aos seus comunicados. Acompanhe nesta área apenas seus próprios avisos.
            </Alert>
          </S.HeaderInfo>

          {loading ? (
            <S.Main>
              <S.List>
                <LoadingCards />
              </S.List>
            </S.Main>
          ) : notifications.length < 1 ? (
            <NoResultsFound
              title='Você ainda não tem Avisos'
              subTitle='Nesta área você pode acompanhar todas as comunicações que receber.'
            />
          ) : (
            <S.Main>
              <S.List>
                {notifications.map((item, index) => renderNotification(item, index))}
                {loadMore()}
              </S.List>
            </S.Main>
          )}

        </S.MainContainer>
      </SideMenuTemplate>
    </SkeletonTheme>
  )
}

export default Notifications
